import {
  delay,
  http,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopInstallmentInfoDownloadResponse } from '@/repositories/generated';

const response: ShopInstallmentInfoDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['削除フラグ', '外部企業ID', '外部店舗ID', '手数料区分', '支払区分', '分割払い支払回数指定', 'ボーナス併用払い支払回数指定', '適用開始日', '予約情報ステータス'],
  ]),
};

export const shopSplitPaymentDownload = http.get(
  createMockEndpoint('/shop/download/split_payment'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
